// Hell/Dunkel: "system" folgt prefers-color-scheme; Auswahl pro Browser gespeichert.
import { useEffect, useState } from 'react';

export type ThemePref = 'system' | 'light' | 'dark';
const KEY = 'dq.theme';

const read = (): ThemePref => {
  try {
    const v = localStorage.getItem(KEY);
    return v === 'light' || v === 'dark' ? v : 'system';
  } catch {
    return 'system';
  }
};
const media = () => (typeof window !== 'undefined' && window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null);
export const resolveTheme = (p: ThemePref): 'light' | 'dark' => (p === 'system' ? (media()?.matches ? 'dark' : 'light') : p);
export const applyTheme = (p: ThemePref) => document.documentElement.setAttribute('data-theme', resolveTheme(p));

export function useTheme() {
  const [pref, setPref] = useState<ThemePref>(read);
  useEffect(() => {
    applyTheme(pref);
    try {
      if (pref === 'system') localStorage.removeItem(KEY);
      else localStorage.setItem(KEY, pref);
    } catch {
      /* privat */
    }
    const m = media();
    if (pref !== 'system' || !m) return;
    const on = () => applyTheme('system');
    m.addEventListener('change', on);
    return () => m.removeEventListener('change', on);
  }, [pref]);
  const resolved = resolveTheme(pref);
  return { pref, resolved, toggle: () => setPref(resolved === 'dark' ? 'light' : 'dark'), setPref };
}
